module.exports = __webpack_public_path__ + "img/icon_kehu_02.95591d12.png";